<template>
  <div
    class="basicInfoLottieBanner"
    :class="{
      'basicInfoLottieBanner--compact': compact,
      'basicInfoLottieBanner--noRightOrb': hideRightOrb,
    }"
  >
    <div class="basicInfoLottieBanner__orb basicInfoLottieBanner__orb--left">
      <lottie :width="lottieSize" :height="lottieSize" :options="leftOptions" />
    </div>

    <div class="basicInfoLottieBanner__content">
      <slot />
    </div>

    <div
      v-if="!hideRightOrb"
      class="basicInfoLottieBanner__orb basicInfoLottieBanner__orb--right"
    >
      <lottie :width="lottieSize" :height="lottieSize" :options="rightOptions" />
    </div>
  </div>
</template>

<script>
import LottiePlayer from '../../../../../components/lottie/index.vue'
import {
  LOTTIE_BANNER_LEFT,
  LOTTIE_BANNER_RIGHT,
  buildLottieOptions,
} from './basicInfoLottiePresets'

export default {
  name: 'BasicInfoLottieBanner',
  components: { Lottie: LottiePlayer },
  props: {
    lottieSize: {
      type: Number,
      default: 52,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    /** 仅保留左侧 orb，右侧空间让给内容区（zip 包要求等宽内容场景） */
    hideRightOrb: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      leftOptions: buildLottieOptions(LOTTIE_BANNER_LEFT),
      rightOptions: buildLottieOptions(LOTTIE_BANNER_RIGHT),
    }
  },
}
</script>

<style scoped>
.basicInfoLottieBanner {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr) 56px;
  align-items: center;
  gap: 8px 10px;
  width: 100%;
  padding: 8px 10px;
  box-sizing: border-box;
  border-radius: 10px;
  background: var(--link-field-bg, #f3f0ea);
  border: 1px solid var(--link-line-strong, #e5dfd6);
}

.basicInfoLottieBanner--compact {
  padding: 6px 8px;
}

.basicInfoLottieBanner--noRightOrb {
  grid-template-columns: 56px minmax(0, 1fr);
}

.basicInfoLottieBanner__orb {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
}

.basicInfoLottieBanner__orb >>> div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.basicInfoLottieBanner__content {
  min-width: 0;
}

@media (max-width: 768px) {
  .basicInfoLottieBanner {
    grid-template-columns: 48px minmax(0, 1fr) 48px;
  }

  .basicInfoLottieBanner--noRightOrb {
    grid-template-columns: 48px minmax(0, 1fr);
  }

  .basicInfoLottieBanner__orb {
    width: 48px;
    height: 48px;
  }
}
</style>
